import { render, staticRenderFns } from "./MatchingCard.vue?vue&type=template&id=0ad2530f&scoped=true&"
import script from "./MatchingCard.vue?vue&type=script&lang=ts&"
export * from "./MatchingCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad2530f",
  null
  
)

export default component.exports